(() => {
  if (customElements.get('bauble-name-generator')) return;
  const documents = {};
  function loadDocument(url) {
    if (!documents[url]) documents[url] = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = () => { delete documents[url]; script.remove(); reject(new Error('Generator asset could not load')); };
      document.head.appendChild(script);
    });
    return documents[url];
  }
  customElements.define('bauble-name-generator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const frame = this.querySelector('iframe'), status = this.querySelector('[role="status"]');
      frame.setAttribute('scrolling', 'no');
      frame.style.overflow = 'hidden';
      this.receive = event => {
        if (event.source !== frame.contentWindow || event.data?.type !== 'name-generator-height') return;
        const height = Number(event.data.height);
        if (Number.isFinite(height) && height > 0) frame.style.height = Math.ceil(Math.max(500, height)) + 'px';
      };
      window.addEventListener('message', this.receive);
      loadDocument(this.dataset.asset).then(() => {
        if (!this.isConnected) return;
        const html = window.ShopifyBaubleGeneratorDocuments?.[this.dataset.design];
        if (!html) throw new Error('Missing design');
        frame.onload = () => { status.hidden = true; };
        frame.srcdoc = html;
      }).catch(() => { status.textContent = 'The generator could not load. Please refresh the page.'; });
    }
    disconnectedCallback() { window.removeEventListener('message', this.receive); this.initialized = false; }
  });
})();
